import Container from "@/src/components/Container/Container";
import Grid from "@mui/material/Grid";
import ChipLegalbird from "@/src/components/legalbird/ChipLegalbird/ChipLegalbird";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import { Button, Divider, Stack } from "@mui/material";
import { formatNumber } from "@/src/services/formatService";
import Section from "@/src/components/Section/Section";
import { useAuthDialog } from "@/src/provider/AuthDialog/AuthDialogProvider";

const StatisticsSection = () => {
  const { setView } = useAuthDialog();

  const statsData = [
    {
      value: 51979,
      label: "Menschen bei ihrem rechtlichen Anliegen begleitet",
    },
    {
      value: 154334,
      label: "Persönlich geschriebene Nachrichten",
    },
    {
      value: 44690,
      label: "Geführte Beratungsgespräche",
    },
  ];

  return (
    <Section>
      <Container variant={"lg"} showVerticalPadding={false}>
        <Grid container sx={{ justifyContent: "space-between" }}>
          <Grid
            size={{
              xs: 12,
              sm: 6,
            }}
          >
            <Box sx={{ paddingTop: "2rem" }}>
              <ChipLegalbird label="Legalbird in Zahlen" />
              <Typography variant={"h3"}>Bei uns ist Ihr Recht in den besten Händen</Typography>
              <Typography sx={{ marginBottom: "1rem" }}>
                Durch Ihre persönliche Servicewelt sehen Sie 24/7 den Fortschritt Ihres Falles und kommunizieren direkt mit uns. Im Hintergrund arbeiten wir an
                der besten Lösung und nutzen dafür unsere Erfahrung aus über hunderttausend Fällen.
              </Typography>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ width: { xs: "100%", sm: "auto" } }}>
                <Button variant={"contained"} onClick={() => setView({ type: "login" })} sx={{ minWidth: { xs: "auto", sm: "12rem" } }}>
                  Anmelden
                </Button>
                <Button variant={"outlined"} onClick={() => setView({ type: "register" })} sx={{ minWidth: { xs: "auto", sm: "12rem" } }}>
                  Jetzt registrieren
                </Button>
              </Stack>
            </Box>
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 4,
            }}
          >
            <Divider sx={{ marginBottom: "2rem", marginTop: "2rem" }} />

            <Stack divider={<Divider />} spacing={4}>
              {statsData.map((stat) => (
                <Box key={stat.label}>
                  <Typography component={"strong"} variant={"h2"}>
                    {formatNumber(stat.value)}
                  </Typography>
                  <Typography variant={"body2"}>{stat.label}</Typography>
                </Box>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
};

export default StatisticsSection;
